import { useUser } from "@/stores/auth";
import { Avatar, Flex, Group, Menu, Text, UnstyledButton } from "@mantine/core";
import { IconLogout, IconSettings, IconUser } from "@tabler/icons-react";
import { useNavigate } from "react-router";

export function UserMenu({ onSignOut }: { onSignOut: () => void }) {
  const user = useUser();
  const navigate = useNavigate();

  return (
    <Menu withArrow shadow="md" width={250} position="bottom-end">
      <Menu.Target>
        <UnstyledButton>
          <Group gap={8}>
            <Avatar size={32} src="/avatars/user.png" />
          </Group>
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Flex
          p="lg"
          w="100%"
          align="center"
          justify="center"
          direction="column"
          gap={8}
        >
          <Avatar size={70} src="/avatars/user.png" />
          <Flex align="center" justify="center" direction="column" gap={0}>
            <Text fw={600} fz={16}>
              {user?.username || "User Name"}
            </Text>
            <Text fz={14} c="gray.9" lh={1}>
              {user?.email || "user@example.com"}
            </Text>
          </Flex>
        </Flex>
        <Menu.Item
          p="xs"
          leftSection={<IconUser size={18} />}
          onClick={() => navigate("/profile")}
        >
          My account
        </Menu.Item>
        <Menu.Item
          p="xs"
          leftSection={<IconSettings size={18} />}
          onClick={() => navigate("/profile")}
        >
          Settings
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          p="xs"
          leftSection={<IconLogout size={18} />}
          onClick={onSignOut}
          color="red"
        >
          Logout
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
